import { Injectable } from '@angular/core';
import { JwtService } from './jwt.service';
import { ConstantValues } from '../../common/constant-values';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private jwtService: JwtService) { }

  // Mock user data
  private permisssionIds: any;

  isLoggedIn(): boolean {
    var token = localStorage.getItem(ConstantValues.TokenKey);
    if (token)
      return true;
    else
      return false;
  }

  getPermissionIds() {
    var token = localStorage.getItem(ConstantValues.TokenKey);
    if (token) {
      var isValid = this.jwtService.isValidToken(token);
      console.log('isValid', isValid)
      if (isValid) {
        var decodedToken = this.jwtService.decodeToken(token);
        console.log('decodedToken', decodedToken)
        localStorage.setItem(ConstantValues.TerminalId, decodedToken.Terminal);
        localStorage.setItem(ConstantValues.BranchId, decodedToken.Branch);
        localStorage.setItem(ConstantValues.UserRole, decodedToken.UserRole);
        const menuList = JSON.parse(decodedToken.Menu);
        console.log('menuList', menuList)
        this.permisssionIds = menuList.map((menu: any) => menu.ClaimValue);

      } else {
      }
    }
    return this.permisssionIds;
  }

  getUserRoleAndUserName(): { userRole: string, userName: string } | null {
    var token = localStorage.getItem('pms-token');
    if (token) {
      var decodedToken = this.jwtService.decodeToken(token);
      if (decodedToken) {
        const userRole = decodedToken?.UserRole;
        const userName = decodedToken?.UserName;
        return { userRole, userName};
      }
    }
    return null;
  }
}
